import { Component, HostListener,EventEmitter, Output , TemplateRef , ElementRef, ViewChild, } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, Params, ActivatedRoute } from "@angular/router";
import { HttpClient, HttpClientModule, HttpHeaders } from "@angular/common/http";
import { RouterModule } from '@angular/router';
import { FormsModule } from "@angular/forms";
import { FilterPipeModule } from 'ngx-filter-pipe';
import { Ng2SearchPipeModule } from '@ngx-maintenance/ng2-search-filter';
import { NgPipesModule } from 'ngx-pipes';
import { ApidataService } from "../apidata.service";
import {NgbModal, ModalDismissReasons}   from '@ng-bootstrap/ng-bootstrap';
import { LogoutComponent } from '../logout/logout.component';
import {  NavigationEnd, RouterLink } from '@angular/router';
import { filter } from 'rxjs/operators';
import { SidebarNewCompComponent } from '../sidebar-new/sidebar-new-comp/sidebar-new-comp.component';

@Component({
  selector: 'app-open-sidebar',
  standalone: true,
  imports: [CommonModule,HttpClientModule,RouterModule,NgPipesModule,
    FilterPipeModule,
    Ng2SearchPipeModule,SidebarNewCompComponent,
    FormsModule, RouterModule],
  templateUrl: './open-sidebar.component.html',
  styleUrl: './open-sidebar.component.css'
})
export class OpenSidebarComponent {
  constructor( private router: Router,    private apirequest:ApidataService,private route: ActivatedRoute, private modalService: NgbModal,){
    this.router.events
    .pipe(filter(event => event instanceof NavigationEnd))
    .subscribe(() => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });

  }
  public checkbackdoclink;
  sidebarExpanded = false;
  isUserLoggedin: boolean = false;

 
  toggleSidebarExpanded() {
    this.sidebarExpanded = !this.sidebarExpanded;
  }


  public navigatetohome(){

    this.router.navigate(['/'])
  }
  public backtoeditor(){
    this.router.navigate(['/openfile'])
  }
  navigatetoaccount(){
    // this.router.navigate(['/accountsettings']);
    const url = this.router.serializeUrl(this.router.createUrlTree(['/accountsettings']));
    window.open(url, '_blank');
  }


 

  openLogout() {
    this.modalService.open(LogoutComponent, { ariaLabelledBy: 'modal-basic-title' });
    const backdrop = document.querySelector('.modal-backdrop');
    if (backdrop) {
      backdrop.remove(); // Remove the backdrop from DOM
    }
  }


  navbarLinksLogIn = [
   
    {
      icon: 'accountIcon',
      function: this.navigatetoaccount.bind(this),
      text: 'Account',
    },
    {
      icon: 'logoutIcon',
      function: this.openLogout.bind(this),
      text: 'Logout',
    },
  ];
}

